import 'react-app-polyfill/stable'
import 'core-js'
import '@fontsource/inter'
import './index.css'
import { setupAutoHideScrollbars } from './lib/autoHideScrollbars'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './store'
import { ThemeProvider } from './components/layout'

setupAutoHideScrollbars()

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <PersistGate loading={loading} persistor={persistor}>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </PersistGate>
  </Provider>
)

reportWebVitals()
